<template>
  <b-form-group :description="description"
                class="container-input"
                :valid-feedback="successMensage"
                :invalid-feedback="msgError"
                :erro-state="erroState">
    <label v-if="label.length"
           :class="colLabel ? `label col-${colLabel}` : 'label'" 
           :for="`custom-input-${name}`">{{ label }} <span class="text-danger">{{ required ? ' *' : '' }}</span></label>
    <b-form-input :id="`custom-input-${name}`"
                  v-model="value"
                  v-mask="setMask"
                  v-money="propMoney ? money : ''"
                  :size="size"
                  :class="colInput ? `custom-input col-${colInput} m-0 p-0` : 'custom-input m-0'"        
                  :type="type"
                  :name="name"
                  :disabled="disabled || false"
                  :state="required ? erroState : null"
                  :placeholder="placeholder"
                  @change="(ev) => value = ev"
                  @blur="handleValidade($event)"
                  @click="handleValidade($event)" />
  </b-form-group>
</template>

<script>
  import { VMoney } from 'v-money'

  // Utils
  import { validators } from './functions'
  import { ValidateMask } from './functions'

  export default {
    name: 'CustomInput',
    directives: {
      money: VMoney
    },
    props: {
      name: { type: String, required: true }, // Identificador único para o input (obrigatório) - deve ser igual ao data do componente pai
      label: { type: String, default: '' }, // Rótulo do input (obrigatório)
      initialValue: {type: [String, Number], default: ''}, // Valor inicial do input (opcional)
      type: { type: String, default: 'text' }, // Tipo do input (text, number, date, time, password, etc.)
      placeholder: { type: String, default: null }, // Mensagem exibida antes do usuário digitar o valor (opcional) 
      maskType: { type: String, default: '' }, // Tipo de máscara para o input, como telefone, cpf, cep, etc. (opcional)
      propMoney: {type: Boolean, default: false}, // Booleano que determina se o input será para valores monetários (opcional)
      customErrorMensage: {type: String, default: ''}, // Mensagem de erro personalizada caso o valor não passe na validação (opcional)
      successMensage: {type: String, default: ''}, // Mensagem de sucesso caso o valor passe na validação (opcional)
      validateType: {type: String, default: null}, // Define a validação que deve ser chamada, como dinheiro, cep, cpf, etc. (opcional)
      required: {type: Boolean, default: false}, // ooleano que determina se o input é obrigatório (opcional)
      description: {type: String, default: ''}, // Mensagem descritiva para o input (opcional)
      formErros: {type: Array, default: null}, // Array que armazena os erros do formulário (opcional)
      disabled: {type: Boolean, default: false}, // Desabilita input
      colLabel: {type: Number, default: 0}, // Define isoladamente o tamanho do label via Bootstrap
      colInput: {type: Number, default: 0}, // Define isoladamente o tamanho do input via Bootstrap
      size: {type: String, default: 'md'}
    },
    data () {
      return {
        value: '',
        erroState: null,
        msgError: 'Campo obrigtório',
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },
      }
    },
    computed: {
      setMask () { // Computed que define qual a máscara a ser utilizada para o input, de acordo com o tipo especificado na prop maskType
        return ValidateMask(this.maskType)
      }   
    },
    watch: { // Reseta statado de erro sempre que o value muda
      value () {
        this.erroState = null
      },
      initialValue () {
        this.init()
        this.value = this.initialValue
      },
    },
    created () {   
      this.init()
    },
    methods: {
      init () {
        if (this.initialValue) {
          this.value = this.initialValue
          this.$emit('blur', this.name, this.initialValue)
          this.updateErrorForm(false)
        }
        if (this.customErrorMensage) this.msgError = this.customErrorMensage // Caso exista uma mensagem de erro personalizada, torna-a padrão

        if (this.required &&
          !this.initialValue &&
          this.formErros) {
          this.updateErrorForm(true)
        } // Adiciona o input ao array de erros para validação inicial no componente pai
      },
      handleValidade () { 
        const { value, type, required, validateType } = this
        const isEmpty = value === null || value === undefined || String(value).trim().length === 0
        const isRequired = required
        const isRequiredAndEmpty = isEmpty && isRequired

        // Validação do tipo 'date' & 'time'
        if (type === 'date') return this.handlerDateType(value, required)
        if (type === 'time') return this.handlerTimeType(value, required)

        if (isRequiredAndEmpty) return this.setError()
        if (!isEmpty && !validateType) this.setValue(value)
        // Realida validação dinamica
        if (validateType && !isEmpty) {
          const validate = validators[validateType]            
          this.erroState = validate.validate(value, required)
          if (this.erroState === false) return this.setError(validate.message)
          return this.setValue(validate.getValue(value))
        }
        // Se chegar até aqui significa que o campo está em branco e não é requerido
        if (isEmpty) {
          if (this.formErros) this.updateErrorForm(false) // caso houver erro anterior retiramos do arrayde erros
          return this.$emit('blur', this.name, null) // reiniciamos  valor do componente pai pra evitar erros
        }
      },
      handlerDateType (value, isRequired) {
        const date = new Date(value) // cria um objeto de data com o valor do input
        const isDateValid = date instanceof Date && !isNaN(date)
        
        if (isRequired && !isDateValid) { // verifica se o objeto de data criado é inválido
          this.setError('Formato invalido')
          this.erroState = false
          return
        }
        if (isDateValid) {
          this.setValue(value)
          this.erroState = true
          return this.updateErrorForm(false)
        }
      },
      handlerTimeType (value, isRequired) {
        // cria um objeto de data com o valor do input
        const data = new Date(`1970-01-01T${value}:00`)

        // verifica se o objeto de data criado é inválido
        if (isNaN(data.getTime()) && isRequired) {
          this.setError('Formato invalido')
          return
        }
        // verifica se o objeto de data não existe
        // define o valor do pai como NULL para evitar erros caso haja dado anterior
        if (isNaN(data.getTime())) return  this.setError('Formato invalido')
  
        // Atualiza o valor do componente pai
        if (!isNaN(data.getTime())) {
          this.setValue(value)
          this.erroState = true
          this.updateErrorForm(false)
          return true
        }
      },
      setValue (value) {
        if (this.formErros) this.updateErrorForm(false) // remove esse input ao array de erro do componente pay 
        if (this.type === 'number') value = Number(value)
        this.$emit('blur', this.name, value)
      },
      setError (msgError) {
        this.erroState = false // Lida com mensagens de erro e sucesso no input
        if (this.formErros) this.updateErrorForm(true) // add esse input ao array de erro do componente pay 
        if (msgError && !this.customErrorMensage) this.msgError = msgError // Seta a mensagem de acordo a validação
        this.$emit('blur', this.name, null)  // Reinicia o valor do componente pai para evitar erros
      },
      updateErrorForm (add) {
        if (!this.formErros) return
        const arr = this.formErros
        const erroAlredyExist = arr.includes(this.name)
        if (add && !erroAlredyExist) {
          arr.push(this.name)
        } else if (!add && erroAlredyExist) {
          const index = arr.indexOf(this.name)
          arr.splice(index, 1)
        }
        this.$emit('setError', arr)
      },
    },
  }
</script>

<style  >
  .container-input {
    margin: 0;
    padding: 0;
  }
  .label {
    font-size: 18px;
    font-weight: 500;
    color: rgb(51, 50, 50);
    padding-bottom: 6px;
  }
  .custom-input {
    margin: 0;
    padding-block-start: 0.625em !important;
    padding-inline-start: 0.75em !important;
    padding-inline-end: 0.75em !important;
    padding-block-end: 0.625em !important;
    text-align: left;
  }
</style>

<!--
DOCUMENTAÇÃO
  Descrição:
    O componente CustomInput é um input customizado que utiliza a biblioteca BootstrapVue
    e a biblioteca v-money para permitir uma fácil entrada de valores monetários. Ele pode
    ser utilizado em formulários de diversos tipos, como cadastros e formulários de pedidos
    podendo lidar com type: text, number, email, date, time.

    Para conferir ou criar novas validações ou mascaras cheque o arquivo functions em './functions'

  Props:
    name: Identificador único para o input (obrigatório)
    label: Rótulo do input (obrigatório)
    initialValue: Valor inicial do input (opcional)
    type: Tipo do input (text, number, date, time, password, etc.) (obrigatório)
    placeholder: Mensagem exibida antes do usuário digitar o valor (opcional)
    maskType: Tipo de máscara para o input, como telefone, cpf, cep, etc. (opcional)
    propMoney: Booleano que determina se o input será para valores monetários (opcional)
    customErrorMensage: Mensagem de erro personalizada caso o valor não passe na validação (opcional)
    successMensage: Mensagem de sucesso caso o valor passe na validação (opcional)
    validateType: Define a validação que deve ser chamada, como dinheiro, cep, cpf, etc. (opcional)
    required: Booleano que determina se o input é obrigatório (opcional)
    description: Mensagem descritiva para o input (opcional)
    formErros: Array que armazena os erros do formulário (opcional)
    disabled: desabilita input
  
  Eventos:
    v-model:  Usado para manter o stado internamente
    blur: Usado para chamar a validação quando o usuário sai do input e atualizar o componente pai

  Métodos:
    handleValidade: Método que valida o valor inserido no input e atualiza o estado do componente
    handlerDateType: Método que valida o valor inserido no input com tipo de 'date' e atualiza o estado do componente
    handlerTimeType: Método que valida o valor inserido no input com tipo de 'time' e atualiza o estado do componente
    setValue: gerencia o stado de erro, atualiza o array de erros e define o valor do componente pai após passar na validação
    updateErrorForm: gerencia o stado de erro, atualiza o array de erros e seta o valor co coponente pai como 'NULL'
    updateErrorForm: Atualiza o array de erros do componente pai, adicionando(true) ou removendo(false)

  Computed:
    setMask: Computed que define qual a máscara a ser utilizada para o input, de acordo com o tipo especificado na prop maskType.
  
  Funções complementares para componente pai:
      // recebe o this.$emit para atualizar o valor no componente pai
      setValueInput (nome, value) {     
        this.form[nome] = value
      },
      // recebe o this.$emit para atualizar o array de erros no componente pay
      setError (newArray) {
        this.formErros = newArray
      },
  Exmplo importação:
        <template>
          <CustomInput
            class="col-4"
            name="cpf"
            label="CPF"
            placeholder="Digite seu CPF"
            type="text"
            :required="true"
            validate-type="cpfOrCnpj"
            :form-erros="formErros"
            mask-type="cpf"
            @setError="setError"
            @blur="setValueInput" />
        </template>
-->